import { getAgeInYears } from '@repo/utils';

// Formats the bare "X yr(s) younger/older" microbiome age delta phrase.
// Callers add any surrounding punctuation (e.g. the ResultCard wraps it in
// parentheses; the summary card shows it as-is).
// age_at_sampling is stored in days; predictedAge is the model's output in years.
export function formatMicrobiomeAgeDelta(
  ageAtSamplingDays: number,
  predictedAge: number,
): string {
  const delta = getAgeInYears(ageAtSamplingDays) - predictedAge;
  // Round the exact magnitude once, rather than differencing the rounded age:
  // floor(x + 0.5) is not symmetric, so rounding the signed delta would read a
  // year short on the "older" side (-13.5 → 13 instead of 14).
  const magnitude = Math.floor(Math.abs(delta) + 0.5);
  const unit = magnitude === 1 ? 'yr' : 'yrs';
  const direction = delta >= 0 ? 'younger' : 'older';
  return `${magnitude} ${unit} ${direction}`;
}
